// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".basil[data-v-317daa85]{background-color:#f09e00!important}", ""]);
// Exports
module.exports = exports;
